import { render, staticRenderFns } from "./MedicalPrescription.vue?vue&type=template&id=2513d842&scoped=true"
import script from "./MedicalPrescription.vue?vue&type=script&lang=js"
export * from "./MedicalPrescription.vue?vue&type=script&lang=js"
import style0 from "./MedicalPrescription.vue?vue&type=style&index=0&id=2513d842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2513d842",
  null
  
)

export default component.exports